<template>
  <div>
    <v-simple-table v-if="!loading && paymentAmount" dense>
      <template v-slot:default>
        <thead style="color: darkgray">
          <tr>
            <td>Source</td>
            <td>Amount</td>
            <td>Period</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Sales</td>
            <td>
              {{payment.currencySymbol}}
              {{(paymentAmount.amountDetails.sales-paymentAmount.amountDetails.carryOverAmount).toFixed(2)}}
            </td>
            <td>{{paymentAmount.amountDetails.currentPeriod}}</td>
          </tr>
          <tr>
            <td>Modifications</td>
            <td>
              {{payment.currencySymbol}}
              {{(paymentAmount.amountDetails.modifications).toFixed(2)}}
            </td>
            <td>{{paymentAmount.amountDetails.currentPeriod}}</td>
          </tr>
          <tr>
            <td>Carry Over</td>
            <td>{{payment.currencySymbol}}{{paymentAmount.amountDetails.carryOverAmount.toFixed(2)}}</td>
            <td>{{paymentAmount.amountDetails.previousPeriod}}</td>
          </tr>
          <tr>
            <td>Commission</td>
            <td>{{payment.currencySymbol}}{{paymentAmount.amountDetails.referralCommission.toFixed(2)}}</td>
            <td>{{paymentAmount.amountDetails.currentPeriod}}</td>
          </tr>
          <tr>
            <td>Carried Over Commission</td>
            <td>{{payment.currencySymbol}}{{paymentAmount.amountDetails.carryOverReferralCommission.toFixed(2)}}</td>
            <td>{{paymentAmount.amountDetails.previousPeriod}}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div v-else-if="loading" class="text-center">
      <v-progress-circular size="50" indeterminate color="primary"></v-progress-circular>
    </div>
    <p class="v-subheader h3" v-else>
      This payment doesn't have payment information?
    </p>
  </div>
</template>

<script>
import paymentsApi from "@/api/payments";

export default {
  name: "PaymentDetails",
  props: {
    payment: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      paymentAmount: null
    }
  },
  methods: {
  },
  async mounted() {
    if (this.payment.id) {
      this.loading = true;
      try {
        this.paymentAmount = await paymentsApi.getPaymentAmount({
          paymentId: this.payment.id
        });
        console.log('DETAILS', this.paymentAmount);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

